/** Local Search whitelabel theme entry. */

import type { WhitelabelThemeEntry } from '../../types';
import { loclsrchDefaultTheme } from './default';

export { loclsrchWhitelabel } from './default';

export const loclsrchWhitelabelThemeEntry: WhitelabelThemeEntry = {
  themes: {
    default: loclsrchDefaultTheme,
  },
};
